var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04MoiPacienti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1683_9039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4577 16.625V15.0417C13.4577 14.2018 13.1241 13.3964 12.5302 12.8025C11.9363 12.2086 11.1309 11.875 10.291 11.875H3.95768C3.11783 11.875 2.31238 12.2086 1.71851 12.8025C1.12465 13.3964 0.791016 14.2018 0.791016 15.0417V16.625",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12565 8.70833C8.87455 8.70833 10.2923 7.29057 10.2923 5.54167C10.2923 3.79276 8.87455 2.375 7.12565 2.375C5.37675 2.375 3.95898 3.79276 3.95898 5.54167C3.95898 7.29057 5.37675 8.70833 7.12565 8.70833Z",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.209 16.625V15.0417C18.2085 14.34 17.9749 13.6584 17.5451 13.1039C17.1152 12.5494 16.5133 12.1533 15.834 11.9779",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.666 2.47791C13.3472 2.65231 13.9509 3.04846 14.3821 3.6039C14.8132 4.15934 15.0472 4.84248 15.0472 5.54561C15.0472 6.24875 14.8132 6.93188 14.3821 7.48733C13.9509 8.04277 13.3472 8.43892 12.666 8.61332",
    stroke: "#8F9DC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1683_9039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04MoiPacienti);
export default __webpack_public_path__ + "static/media/04-moi-pacienti.1edc851f2ad70fe441d03940d988c199.svg";
export { ForwardRef as ReactComponent };